module.exports = __webpack_public_path__ + "static/CAREGMP-a52bbf396cc8780913d9c035c4b93862.png";